<template>
  <div class="wrap-qrcode">
    <img class="code-img" v-if="setPicSize(imgData, 120, 120)" :src="setPicSize(imgData, 120, 120)" alt="">
    <div class="desc">
      <div class="title">{{title}}</div>
      <div class="price" v-if="price">{{price}}</div>
      <div class="tag" v-if="tagName">{{tagName}}</div>
    </div>
  </div>
</template>
<script>
import PicUtils from '../../../utils/pic-util'

export default {
  computed: {
    tagName() {
        if(this.articleData.useTag == 1) {
            return this.articleData.tagName
        }
        return
    },
    title() {
      if(this.articleData && this.articleData.fields && this.articleData.fields.title ){
        return this.articleData.fields.title
      }
      return ''
    },
    // 二维码商品价格
    price() {
      let data = this.articleData && this.articleData.fields;
      let xmlData = JSON.parse(data && data.xmljson);
      let price = xmlData && xmlData.xml && xmlData.xml.productPrice
      if(typeof price !== 'undefined' && price !== '')return '￥' + Number(price).toFixed(2)
      return ''
          
    },
    imgData() {
      let status = this.articleData && this.articleData.status
      if (status === 1 || status === 5) {
        let data = this.articleData && this.articleData.fields;
        let xmlData = JSON.parse(data && data.xmljson);
        let img = xmlData && xmlData.xml && xmlData.xml.position && xmlData.xml.position[0] && xmlData.xml.position[0].qrimageUrl;
        return img;
      }
    },
  },
  methods: {
    setPicSize(url, width, height){
        return PicUtils.setPicSize(url, width, height);
    }
  }
};
</script>
<style lang="less" scoped>
.wrap-qrcode {
    width: 650px;
    height: 176px;
    margin:0 auto;
    padding: 16px 32px 16px 16px;
    background: #FFFFFF;
    border: 2px solid #E5E5E5;
    display: flex;
    margin-bottom:30px;
    .code-img{
      width:176px !important;
      height:176px !important;
      display: block;
    }
    .desc{
      position: relative;
      margin-left: 32px;
      width: 442px;
      height: 176px;
      box-sizing: border-box;
      padding-top: 8px;
      .title{
        font-size: 32px;
        color: #3C3C3D;
        line-height: 44px;
      }
      .price{
        position: absolute;
        display: block;
        bottom: 8px;
        left: 0px;
        height: 50px;
        font-size: 36px;
        font-weight: 500;
        color: #F94A25;
        line-height: 50px;
      }
      .tag {
        position: absolute;
        display: block;
        bottom: 4px;
        right: 0px;
        height: 40px;
        padding-left: 8px;
        padding-right: 8px;
        background: #F2F2F2;
        font-size: 24px;
        color: #999999;
        line-height: 40px;
        text-align: center;
    }
    }
    
}
</style>